<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :formCtrl="mformCtrl"
      :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>

    <FormDialog ref="dialog2" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :formCtrl="mformCtrl2"
      :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  name: "VehicleGroupList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'cararray',
      formInline: {},
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "buytime", label: "购入时间" },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id, license }) => {
            // console.log(id, license)
            this.title = '车组修改'
            this.mform = {}
            this.mform.carid = id
            this.mform.license = license
            // console.log({ ...this.mform })
            // this.mformCtrl = this.mformCtrl2
            this.$forceUpdate()
            this.showDialog('dialog2')
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '车组添加',
      viewMode: false,
      mform: {},
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "carid",
          err: "请填写车牌号",
          type: "select",
          options: [],
        },
        {
          label: "车组名",
          keyName: "aid",
          err: "请填写车组名",
          type: "select",
          options: [],
        },
      ],
      mformCtrl1: [
        {
          label: "车牌号",
          keyName: "carid",
          err: "请填写车牌号",
          type: "select",
          options: [],
        },
        {
          label: "车组名",
          keyName: "aid",
          err: "请填写车组名",
          type: "select",
          disabled: true,
          options: [],
        },
      ],
      mformCtrl2: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          disabled: true,
        },
        {
          label: "车组名",
          keyName: "aid",
          err: "请填写车组名",
          type: "select",
          options: [],
        },
      ],
      getListUrl: 'driverec',
      baseParams: ['aid'],
      cars: [],
      tabData: [],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    getData() {
      this.loading = true
      this.tabData = [];
      let url = `${this.baseUrl}/carlist`;
      const params = {
        // userid: this.user.id,
      }
      // console.log(url, params)
      this.post(url, params, ({ car, cararray }) => {
        this.loading = false
        this.cars = car.map(c => {
          return {
            label: c.license,
            value: c.id,
          }
        })
        this.setState({
          key: 'cararray',
          value: cararray,
        })
        this.tabData = cararray.map(c => {
          return {
            label: c.arrname,
            value: c.id,
          }
        })
        this.mformCtrl.map(v => {
          if (v.keyName == 'carid') {
            v.options = this.cars
          }
          if (v.keyName == 'aid') {
            v.options = this.tabData
          }
        })
        this.mformCtrl1.map(v => {
          if (v.keyName == 'carid') {
            v.options = this.cars
          }
          if (v.keyName == 'aid') {
            v.options = this.tabData
          }
        })
        this.mformCtrl2.map(v => {
          if (v.keyName == 'carid') {
            v.options = this.cars
          }
          if (v.keyName == 'aid') {
            v.options = this.tabData
          }
        })
        const { idx } = this.$route.params
        // this.formInline.aid = cararray[idx - 1].id
        this.formInline.aid = idx
        this.$nextTick(this.getList);
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setParams(idx) {
      const { cararray } = this.store
      if (cararray && cararray.length) {
        // this.formInline.aid = cararray[idx].id
        let obj = cararray.find(i => {
          return i.id == idx && i
        })
        this.formInline.aid = obj.id
      }
      this.getList()
    },
    addItem() {
      this.title = '车组添加'
      this.mform = {}
      this.mform.aid = this.formInline.aid
      this.mformCtrl = this.mformCtrl1
      this.$forceUpdate()
      this.showDialog()
    },
    onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/addarray`;
      const params = {
        ...data,
      }

      // const opt = this.title === '车组修改' ? 'update' : 'create'

      params['headers'] = {
        'X-Method': 'update',
        'X-Module': 'fleet_group',
      }

      console.log(url, { ...params })

      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    delReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/${this.delUrl}`;
      const params = {
        userid: this.user.id,
        carid: id,
      }

      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': 'fleet_group',
      }

      console.log(url, { ...params })

      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: '删除失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
  },
  watch: {
    $route(route) {
      // console.log(from, to)
      let idx = route.params.idx
      // console.log(from.params.idx, to.params.idx)
      this.setParams(idx)
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }
}
</style>
